import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import * as Types from 'types';
import { PlaylistHero } from 'playlists/components/PlaylistHero';
import { requestPublicPlaylists } from 'features/playlists/api';
import { checkoutPlan } from 'apps/art-stream/services/checkout';
import {
  PlaylistResponse,
  mapPlaylistResponseToPlaylist,
} from 'features/playlists/api';

declare global {
  interface Window {
    ART_STREAM_PLAYLISTS: undefined | PlaylistResponse[];
  }
}

const interiorForIndex = (index: number) =>
  ['mac', 'moscow', 'loft'][index % 3] as 'mac' | 'moscow' | 'loft';

type Props = {};

export const ArtStreamLanding: React.FC<Props> = () => {
  const [playlists, setPlaylists] = useState<Types.Playlist[]>(
    window.ART_STREAM_PLAYLISTS
      ? window.ART_STREAM_PLAYLISTS.map(mapPlaylistResponseToPlaylist)
      : [],
  );

  useEffect(() => {
    if (playlists.length === 0) {
      requestPublicPlaylists().then(setPlaylists);
    }
    const planToCheckout = Cookies.get('post_signup_stripe_checkout');
    if (planToCheckout === 'monthly' || planToCheckout === 'yearly') {
      Cookies.remove('post_signup_stripe_checkout');
      checkoutPlan(planToCheckout);
    }
  }, []);

  if (playlists.length === 0) {
    return null;
  }

  return (
    <div>
      {playlists.map((playlist, index) => (
        <PlaylistHero
          key={index}
          playlist={playlist}
          interior={interiorForIndex(index)}
        />
      ))}
    </div>
  );
};
